import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EnvironmentService } from '../environment.service';
import { Observable, BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class NotificationsService {
  apiBaseURL!: string;
  notificationUpdated$ = new BehaviorSubject<boolean>(false);

  constructor(
    private readonly http: HttpClient,
    environmentService: EnvironmentService
  ) {
    //Get Bulk Upload URL as base URL
    this.apiBaseURL = environmentService.getBulkUplodUrl();
  }

  notificationGetByUserID(): Observable<any> {
    return this.http.get<any>(`${this.apiBaseURL}notify`);
  }

  markasRead(id: string) {
    return this.http.post(`${this.apiBaseURL}notify/read`, { id });
  }

  markasReadAll(id: string) {
    return this.http.post(`${this.apiBaseURL}notify/read-all`, { userId: id });
  }
  sendMessagetoSocket(payload: any) {
    return this.http.post(`${this.apiBaseURL}notify/socket`, payload);
  }

  getAllNotifications(page: number = 0, size: number = 10): Observable<any> {
    return this.http.get<any>(`${this.apiBaseURL}notify/all?page=${page}&size=${size}`);
  }


  clearAll(userID: string): Observable<any> {
    return this.http.post<any>(`${this.apiBaseURL}notify/clear-all`, { userId: userID });
  }

  triggerNotificationUpdate(): void {
    this.notificationUpdated$.next(true);
  }
}
